module.exports = __webpack_public_path__ + "static/img/1000003icon.3437a19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1000003icon.png
// module id = 9UhF
// module chunks = 1